import React from 'react';
import { Button, Flex, FlexColumn, Text } from 'core/components';
import Comment from './Comment';

/** CommentList's thread look: a sort toggle over a scrolling box of comment rows, with the composer below. */
const CommentThreadList = ({ comments, newestFirst, listRef, composer, onSortToggle }) => (
  <>
    {comments.length === 0 ? (
      <Text small muted>
        No comments yet.
      </Text>
    ) : (
      <>
        <Flex justifyContent="flex-end" mb={1}>
          <Button
            minimal
            small
            icon="sort"
            text={newestFirst ? 'Newest first' : 'Oldest first'}
            onClick={onSortToggle}
          />
        </Flex>
        <FlexColumn
          ref={listRef}
          role="list"
          gap="2px"
          maxHeight={420}
          overflowY="auto"
          overflowX="hidden"
          p="4px"
          border="thin"
          borderRadius={8}
          bg="cardBackground"
        >
          {comments.map((comment) => (
            <Comment key={comment.id} model={comment} entityType={comment.get('entityType')} variant="thread" />
          ))}
        </FlexColumn>
      </>
    )}
    {composer}
  </>
);

export default CommentThreadList;
